import { MutableValue } from "../api/mutable-value.interface";

export default class Sender implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fEmail: string,
    private fName: string
  ) {
    [fId, fEmail, fName].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get email(): string {
    return this.fEmail;
  }

  get name(): string {
    return this.fName;
  }
}
